// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r2fP","buttons":"styles_buttons__YeQQm"};